module.exports = __webpack_public_path__ + "img/Chambroad-icon.bfc101c8.png";